import { useState } from "react";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ChatWidget from "../../components/feature/ChatWidget";
import SEOHead from "../../components/feature/SEOHead";

const siteUrl = import.meta.env.VITE_SITE_URL ?? "https://vidalferrerassessors.es";

const contactoJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contacto · Vidal Ferrer Asesores",
    "description": "Contacta con Vidal Ferrer Asesores en Pego. C/ Duanes 14, teléfono +34 96 557 18 31. Primera consulta gratuita sin compromiso. Respuesta en menos de 24h.",
    "url": `${siteUrl}/contacto`,
    "mainEntity": {
      "@type": "AccountingService",
      "name": "Vidal Ferrer Asesores",
      "telephone": "+34965571831",
      "email": "assessoriagrevi@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "C/ Duanes, 14",
        "addressLocality": "Pego",
        "addressRegion": "Alicante",
        "postalCode": "03780",
        "addressCountry": "ES"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 38.8422,
        "longitude": -0.1211
      },
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "13:00"
        },
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday"],
          "opens": "16:00",
          "closes": "19:00"
        }
      ]
    }
  }
];

export default function ContactoPage() {
  const [form, setForm] = useState({
    nombre: "",
    email: "",
    telefono: "",
    servicio: "",
    mensaje: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const msgLen = form.mensaje.length;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (msgLen > 500) return;
    setSubmitting(true);
    setError(false);
    try {
      const body = new URLSearchParams({
        nombre: form.nombre,
        email: form.email,
        telefono: form.telefono,
        servicio: form.servicio,
        mensaje: form.mensaje,
      });
      const res = await fetch("https://readdy.ai/api/form/d7598mf5hic0eqh31hs0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      if (res.ok) {
        setSuccess(true);
        setForm({ nombre: "", email: "", telefono: "", servicio: "", mensaje: "" });
      } else {
        setError(true);
      }
    } catch {
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <SEOHead
        title="Contacto · Consulta Gratuita en Pego | Vidal Ferrer Asesores"
        description="Contacta con Vidal Ferrer Asesores en Pego. C/ Duanes 14, tel. +34 96 557 18 31. Primera consulta gratuita sin compromiso. Respuesta en menos de 24h."
        keywords="contacto asesoría Pego, consulta gratuita fiscal Alicante, teléfono gestoría Pego, cita asesor Marina Alta"
        canonical="/contacto"
        jsonLd={contactoJsonLd}
      />
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-16 bg-[#F0F4ED]">
          <div className="max-w-screen-xl mx-auto px-6 md:px-10 text-center">
            <p className="text-[#6B7F5C] text-sm font-semibold uppercase tracking-widest mb-4">Estamos aquí para ti</p>
            <h1 className="text-4xl md:text-6xl font-bold text-[#1A1A1A] mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
              Contacto
            </h1>
            <p className="text-[#6B6B6B] text-lg max-w-xl mx-auto">
              ¿Tienes alguna pregunta o necesitas asesoramiento? Escríbenos y te responderemos en menos de 24 horas.
            </p>
          </div>
        </section>

        {/* Contact section */}
        <section className="py-20 bg-white">
          <div className="max-w-screen-xl mx-auto px-6 md:px-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-14">
              {/* Info column */}
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-[#1A1A1A] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                  ¿Cómo podemos ayudarte?
                </h2>
                <p className="text-[#6B6B6B] leading-relaxed mb-8">
                  Contamos con un equipo de asesores especializados listos para analizar tu caso. La primera consulta es gratuita y sin compromiso.
                </p>

                {/* Contact details */}
                <div className="space-y-5 mb-10">
                  {[
                    { icon: "ri-phone-line", label: "TELÉFONO", value: "+34 96 557 18 31 / +34 623 619 606", sub: "Lunes a Viernes, 9:00 – 19:00h" },
                    { icon: "ri-mail-line", label: "EMAIL", value: "assessoriagrevi@gmail.com", sub: "Respuesta en menos de 24h" },
                    { icon: "ri-map-pin-line", label: "OFICINA", value: "C/ Duanes, 14", sub: "PEGO 03780, España" },
                    { icon: "ri-time-line", label: "HORARIO", value: "Mañanas L–V · Tardes L–J", sub: "09:00 – 13:00 · 16:00 – 19:00h (cita previa)" },
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-4">
                      <div className="w-11 h-11 bg-[#F0F4ED] rounded-xl flex items-center justify-center flex-shrink-0">
                        <i className={`${item.icon} text-[#6B7F5C] text-lg`} />
                      </div>
                      <div>
                        <p className="text-xs font-bold uppercase tracking-widest text-[#6B6B6B] mb-0.5">{item.label}</p>
                        <p translate="no" className="font-semibold text-[#1A1A1A] text-sm">{item.value}</p>
                        <p translate="no" className="text-xs text-[#6B6B6B]">{item.sub}</p>
                      </div>
                    </div>
                  ))}
                </div>

              </div>

              {/* Form column */}
              <div className="bg-[#F8F7F4] rounded-2xl p-8 md:p-10">
                <h3 className="text-xl font-bold text-[#1A1A1A] mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Envíanos tu consulta
                </h3>

                {success ? (
                  <div className="text-center py-12">
                    <div className="w-16 h-16 bg-[#F0F4ED] rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-check-line text-[#6B7F5C] text-3xl" />
                    </div>
                    <h4 className="font-bold text-[#1A1A1A] text-lg mb-2">¡Mensaje recibido!</h4>
                    <p className="text-[#6B6B6B] text-sm">Un asesor se pondrá en contacto contigo en menos de 24 horas.</p>
                    <button
                      onClick={() => setSuccess(false)}
                      className="mt-6 text-[#6B7F5C] text-sm font-medium cursor-pointer hover:underline"
                    >
                      Enviar otro mensaje
                    </button>
                  </div>
                ) : (
                  <form
                    data-readdy-form
                    onSubmit={handleSubmit}
                    className="space-y-5"
                  >
                    <div>
                      <label className="block text-xs font-semibold text-[#4A4A4A] uppercase tracking-wide mb-1.5">
                        Nombre completo *
                      </label>
                      <input
                        type="text"
                        name="nombre"
                        value={form.nombre}
                        onChange={handleChange}
                        placeholder="Tu nombre y apellidos"
                        required
                        className="w-full bg-white border border-gray-200 rounded-lg px-4 py-3 text-sm text-[#2D2D2D] placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#6B7F5C] focus:border-transparent transition-all"
                      />
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-xs font-semibold text-[#4A4A4A] uppercase tracking-wide mb-1.5">
                          Email *
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={form.email}
                          onChange={handleChange}
                          placeholder="tu@email.com"
                          required
                          className="w-full bg-white border border-gray-200 rounded-lg px-4 py-3 text-sm text-[#2D2D2D] placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#6B7F5C] focus:border-transparent transition-all"
                        />
                      </div>
                      <div>
                        <label className="block text-xs font-semibold text-[#4A4A4A] uppercase tracking-wide mb-1.5">
                          Teléfono
                        </label>
                        <input
                          type="tel"
                          name="telefono"
                          value={form.telefono}
                          onChange={handleChange}
                          placeholder="+34 600 000 000"
                          className="w-full bg-white border border-gray-200 rounded-lg px-4 py-3 text-sm text-[#2D2D2D] placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#6B7F5C] focus:border-transparent transition-all"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-[#4A4A4A] uppercase tracking-wide mb-1.5">
                        Tipo de servicio
                      </label>
                      <select
                        name="servicio"
                        value={form.servicio}
                        onChange={handleChange}
                        className="w-full bg-white border border-gray-200 rounded-lg px-4 py-3 text-sm text-[#2D2D2D] focus:outline-none focus:ring-2 focus:ring-[#6B7F5C] focus:border-transparent transition-all cursor-pointer"
                      >
                        <option value="">Selecciona un servicio</option>
                        <option value="Asesoría Fiscal">Asesoría Fiscal</option>
                        <option value="Asesoría Laboral">Asesoría Laboral</option>
                        <option value="Seguros">Seguros</option>
                        <option value="Contabilidad">Contabilidad y Finanzas</option>
                        <option value="Constitución">Constitución de Empresa</option>
                        <option value="Consultoría">Consultoría de Gestión</option>
                        <option value="Otro">Otro</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-xs font-semibold text-[#4A4A4A] uppercase tracking-wide mb-1.5">
                        Mensaje *
                      </label>
                      <textarea
                        name="mensaje"
                        value={form.mensaje}
                        onChange={handleChange}
                        placeholder="Cuéntanos tu situación o consulta..."
                        required
                        rows={4}
                        maxLength={500}
                        className="w-full bg-white border border-gray-200 rounded-lg px-4 py-3 text-sm text-[#2D2D2D] placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#6B7F5C] focus:border-transparent transition-all resize-none"
                      />
                      <p className={`text-xs mt-1 text-right ${msgLen > 480 ? "text-red-400" : "text-gray-400"}`}>
                        {msgLen}/500 caracteres
                      </p>
                    </div>
                    {error && (
                      <p className="text-red-500 text-sm bg-red-50 rounded-lg p-3">
                        Ha ocurrido un error. Por favor, inténtalo de nuevo.
                      </p>
                    )}
                    <button
                      type="submit"
                      disabled={submitting || msgLen > 500}
                      className="w-full bg-[#6B7F5C] hover:bg-[#5A6E4B] text-white font-semibold py-4 rounded-lg transition-colors duration-200 cursor-pointer disabled:opacity-60 text-sm whitespace-nowrap"
                    >
                      {submitting ? "Enviando..." : "Enviar Consulta"}
                    </button>
                    <p className="text-xs text-center text-[#6B6B6B]">
                      Al enviar aceptas nuestra{" "}
                      <a href="#" rel="nofollow" className="text-[#6B7F5C] hover:underline cursor-pointer">
                        política de privacidad
                      </a>
                      .
                    </p>
                  </form>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Location & Hours */}
        <section className="py-20 bg-[#F8F7F4]">
          <div className="max-w-screen-xl mx-auto px-6 md:px-10">
            <div className="text-center mb-14">
              <p className="text-[#6B7F5C] text-sm font-semibold uppercase tracking-widest mb-3">Dónde encontrarnos</p>
              <h2 className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Ven a visitarnos a Pego
              </h2>
              <p className="text-[#6B6B6B] text-base max-w-xl mx-auto">
                Estamos en el centro de Pego. Puedes venir sin cita por las mañanas o llamar para reservar tu franja horaria.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
              {/* Info panel */}
              <div className="lg:col-span-2 space-y-6">

                {/* Address card */}
                <div className="bg-white rounded-2xl p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 bg-[#F0F4ED] rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#6B7F5C] text-lg" />
                    </div>
                    <h3 className="font-bold text-[#1A1A1A] text-base">Dirección</h3>
                  </div>
                  <p translate="no" className="text-[#2D2D2D] font-semibold text-sm">C/ Duanes, 14</p>
                  <p translate="no" className="text-[#6B6B6B] text-sm">03780 PEGO, Alicante, España</p>
                  <a
                    href="https://maps.google.com/maps?q=Carrer+Duanes+14,+03780+Pego,+Alicante,+España"
                    target="_blank"
                    rel="nofollow noopener"
                    className="inline-flex items-center gap-1.5 mt-4 text-[#6B7F5C] text-sm font-semibold hover:gap-2.5 transition-all cursor-pointer whitespace-nowrap"
                  >
                    Abrir en Google Maps
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-external-link-line text-xs" />
                    </div>
                  </a>
                </div>

                {/* Schedule card */}
                <div className="bg-white rounded-2xl p-6">
                  <div className="flex items-center gap-3 mb-5">
                    <div className="w-10 h-10 bg-[#F0F4ED] rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-time-line text-[#6B7F5C] text-lg" />
                    </div>
                    <h3 className="font-bold text-[#1A1A1A] text-base">Horario de atención</h3>
                  </div>
                  <div className="space-y-3">
                    {[
                      { days: "Lunes – Viernes", hours: "09:00 – 13:00", note: "Sin cita previa", open: true },
                      { days: "Lunes – Jueves", hours: "16:00 – 19:00", note: "Con cita previa", open: true },
                      { days: "Sábado", hours: "Cerrado", note: "", open: false },
                      { days: "Domingo", hours: "Cerrado", note: "", open: false },
                    ].map((row, i) => (
                      <div key={i} className={`flex items-center justify-between py-2.5 ${i < 3 ? "border-b border-gray-100" : ""}`}>
                        <div>
                          <p translate="no" className="text-sm font-semibold text-[#1A1A1A]">{row.days}</p>
                          {row.note && <p className="text-xs text-[#6B6B6B] mt-0.5">{row.note}</p>}
                        </div>
                        <span translate="no" className={`text-sm font-semibold whitespace-nowrap ${row.open ? "text-[#6B7F5C]" : "text-[#B0B0B0]"}`}>
                          {row.hours}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div className="mt-5 bg-[#F0F4ED] rounded-xl px-4 py-3 flex items-start gap-2.5">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-information-line text-[#6B7F5C] text-sm" />
                    </div>
                    <p className="text-xs text-[#4A4A4A] leading-relaxed">
                      Para tardes, llama al <span className="font-semibold">+34 96 557 18 31</span> o al <span className="font-semibold">+34 623 619 606</span> para reservar cita.
                    </p>
                  </div>
                </div>

                {/* How to get there */}
                <div className="bg-white rounded-2xl p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 bg-[#F0F4ED] rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-road-map-line text-[#6B7F5C] text-lg" />
                    </div>
                    <h3 className="font-bold text-[#1A1A1A] text-base">Cómo llegar</h3>
                  </div>
                  <div className="space-y-3">
                    {[
                      { icon: "ri-car-line", text: "En coche: aparcamiento en la Plaza del Mercat, a 2 min a pie" },
                      { icon: "ri-bus-line", text: "En autobús: línea Dénia–Gandia, parada centro de Pego" },
                      { icon: "ri-walk-line", text: "A pie: en el casco histórico, junto al Ayuntamiento" },
                    ].map((item, i) => (
                      <div key={i} className="flex items-start gap-3">
                        <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className={`${item.icon} text-[#6B7F5C] text-base`} />
                        </div>
                        <p className="text-sm text-[#4A4A4A] leading-relaxed">{item.text}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Map */}
              <div className="lg:col-span-3 rounded-2xl overflow-hidden h-[540px] lg:h-[620px]">
                <iframe
                  src="https://maps.google.com/maps?q=Carrer+Duanes+14,+03780+Pego,+Alicante,+España&t=&z=16&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  title="Ubicación Vidal Ferrer Asesores — C/ Duanes 14, Pego"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Office photos */}
        <section className="py-16 bg-white">
          <div className="max-w-screen-xl mx-auto px-6 md:px-10">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-[#1A1A1A]" style={{ fontFamily: "'Playfair Display', serif" }}>
                Nuestras instalaciones
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                { src: "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/3d9042f0-0c7f-4c54-be09-c912d142a49d_oficina.jpeg?v=039df7e0b58041e988113fcafe1f893b", alt: "Recepción" },
                { src: "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/fd93eeec-737f-4454-babc-f51671a04baf_oficina-1.jpeg?v=feb3fa10897cf1394f21f562937b3484", alt: "Sala de reuniones" },
                { src: "https://storage.readdy-site.link/project_files/db85668d-0973-4f5a-ac63-8b47d247ab38/5d198e02-b50f-45ba-886f-dccec1174f60_oficina-2.jpeg?v=b61451c6b5da901fd090839ad1b382f6", alt: "Despacho de asesor" },
              ].map((img, i) => (
                <div key={i} className="rounded-2xl overflow-hidden h-56">
                  <img src={img.src} alt={img.alt} title={`Oficina Vidal Ferrer Asesores - ${img.alt}`} className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500" />
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <ChatWidget />
    </>
  );
}
